<template>
  <div>
    <div class="l-bg-white">
      <div class="row bg-grey pt-3">
        <div class="col-12">
          <h3 class="title-h3 border-bottom pb-3">
            <button type="button"
                    class="btn btn-back"
                    @click="$router.push('/settings/claim-types')"
            />
            Back
          </h3>
        </div>
      </div>
      <form @submit.prevent="submit"
            @keydown="clearError($event)"
            autocomplete="no"
      >
        <div class="row pt-3">
          <div class="col-3">
            <div class="select-wrap">
              <label>Claim type name</label>
              <input v-model="claimType.name"
                     type="text"
                     class="form-control"
                     @keyup="toggleEditedNameGroup"
              />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
        </div>

        <div class="row mx-0">
          <div class="col py-3 pl-0 text-left">
            <button type="button"
                    @click="deleteClaimType(claimType.id)"
                    class="btn btn-delete"
                    v-if="$_can('claims.types.destroy')"
            >
              Delete
            </button>
          </div>
          <div class="col py-3 pr-0 text-right">
            <button type="button"
                    @click="getClaimType(claimType.id)"
                    :disabled="!buttonDisabled"
                    class="btn btn-secondary"
            >
              Discard
            </button>
            <button class="btn btn-primary ld-ext-right"
                    v-if="$_can('claims.types.update')"
                    :disabled="!buttonDisabled"
                    :class="loadingButton ? 'running' : ''"
            >
              Save
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import axios from 'axios';
import toastr from 'toastr';
import ErrorField from '../../ErrorField';
import Errors from '../../../classes/Errors';

export default {
  components: {
    ErrorField,
  },
  data: () => ({
    claimType: {
      id: '',
      name: '',
    },
    buttonDisabled: false,
    loadingButton: false,
    errors: new Errors(),
  }),
  mounted() {
    this.getClaimType(this.$route.params.id);
  },
  methods: {
    ...mapActions(['removeClaimType', 'getPaginatedClaimTypes', 'getClaimTypes']),
    getClaimType(id) {
      this.buttonDisabled = false;
      axios
        .get(`claims/types/${id}`)
        .then(res => {
          this.claimType = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    toggleEditedNameGroup() {
      this.buttonDisabled = true;
    },
    submit() {
      this.buttonDisabled = false;
      this.loadingButton = true;
      axios
        .put(`claims/types/${this.$route.params.id}`, this.claimType)
        .then(() => {
          toastr.success('Successfully updated claim type');
          this.getClaimType();
          this.$router.push('/settings/claim-types');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    deleteClaimType(id) {
      axios
        .delete(`claims/types/${id}`)
        .then(() => {
          toastr.success('Successfully deleted claim type');
          this.getClaimType();
          this.$router.push('/settings/claim-types');
        })
        .catch(() => {
          toastr.error('You cannot delete the claim type since it belongs to a claim', '', {
            timeOut: 0,
          });
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/settings/ClaimTypes/SettingsEditClaimType.vue